import { circleGeoJson } from "./geoCircle";
import { applyMapLanguage } from "./mapLabels";
import { RASTER_STYLE } from "./mapConfig";

const FILL = { "fill-color": "#22c55e", "fill-opacity": 0.16 };
const LINE = { "line-color": "#22c55e", "line-width": 2 };

export const drawGeofence = (map, center, radiusM) => {
  if (!map.isStyleLoaded() || map.getSource("geofence")) return;
  map.addSource("geofence", { type: "geojson", data: circleGeoJson(center.latitude, center.longitude, radiusM) });
  map.addLayer({ id: "geofence-fill", type: "fill", source: "geofence", paint: FILL });
  map.addLayer({ id: "geofence-line", type: "line", source: "geofence", paint: LINE });
};

// بعض الأجهزة (آيفون خصوصاً) تفشل في رسم البلاطات المتجهة: نتحقق بعد فترة ونتحوّل لنمط صوري.
export const watchVectorFailure = (map, onFallback) => {
  let done = false;
  const finish = (failed) => {
    if (done) return;
    done = true;
    clearTimeout(timer);
    if (failed) {
      map.setStyle(RASTER_STYLE);
      onFallback();
    }
  };
  const timer = setTimeout(() => {
    const painted = map.queryRenderedFeatures().length > 0;
    finish(!painted);
  }, 6000);
  map.once("idle", () => finish(map.queryRenderedFeatures().length === 0));
  return () => {
    done = true;
    clearTimeout(timer);
  };
};

export const applyStyleExtras = (map, { lang, center, radiusM, raster }) => {
  if (!raster) applyMapLanguage(map, lang);
  drawGeofence(map, center, radiusM);
};
